var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.001,
    r: 16,
    fill: "#FBEAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80817 21.1386L14.1193 9.3655C15.1232 7.49275 17.8768 7.49275 18.8807 9.36549L25.1918 21.1386C26.1246 22.8785 24.8276 24.9609 22.8112 24.9609H10.1888C8.17243 24.9609 6.87544 22.8785 7.80817 21.1386ZM16.5 10.9609C17.0523 10.9609 17.5 11.4087 17.5 11.9609V18.9609C17.5 19.5132 17.0523 19.9609 16.5 19.9609C15.9477 19.9609 15.5 19.5132 15.5 18.9609V11.9609C15.5 11.4087 15.9477 10.9609 16.5 10.9609ZM15.25 21.7109C15.25 22.4013 15.8096 22.9609 16.5 22.9609C17.1904 22.9609 17.75 22.4013 17.75 21.7109C17.75 21.0206 17.1904 20.4609 16.5 20.4609C15.8096 20.4609 15.25 21.0206 15.25 21.7109Z",
    fill: "#E60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b5995482f49e1ddef818ddea27e0f4f5.svg";
export { ForwardRef as ReactComponent };